export default __webpack_public_path__ + "static/media/logo-red.657ea2eb.png";